import {
    HiClipboardList,
} from 'react-icons/hi';
import {HiOutlineCog, HiOutlineDocumentReport} from 'react-icons/hi';
import {
    HiCog8Tooth,
    HiCurrencyDollar,
    HiGiftTop,
    HiHome,
    HiCreditCard,
    HiShieldCheck,
    HiTicket,
    HiUserGroup,
} from 'react-icons/hi2';
import {IoInformationCircle, IoShield} from 'react-icons/io5';
import {BsCurrencyExchange} from 'react-icons/bs';
import {BsPersonBadge} from 'react-icons/bs';
import {RiFundsBoxFill} from 'react-icons/ri';
import {MdAccountBalance} from 'react-icons/md';
import {FaInfoCircle} from 'react-icons/fa';
import { BiBarChartAlt } from "react-icons/bi";
import { IoBarChartSharp } from "react-icons/io5";


function path(root, sublink) {
    return `${root}${sublink}`;
}

export const ROOTS_AUTH = '/auth';
export const ROOTS_APP = '/app';
export const ROOTS_ADMIN = '/admin';

export const ROOTS_DEV = '/dev';

export const devPaths = {
    root: ROOTS_DEV,
    apis: path(ROOTS_DEV, '/api-explorer'),
};

export const authPaths = {
    //auth
    login: path(ROOTS_AUTH, '/login'),
    forgotPassword: path(ROOTS_AUTH, '/forgot-password'),
    resetPassword: path(ROOTS_AUTH, '/reset-password'),
    signUp: path(ROOTS_AUTH, '/sign-up'),
    signUpVerify: path(ROOTS_AUTH, '/sign-up-verify'),
    logout: path(ROOTS_AUTH, '/logout'),
    requiredUpdatePassOtp: path(ROOTS_AUTH, '/required-update-pass-otp'),
};

export const paths = {
    root: ROOTS_APP,
    redirector: path('', '/redirector'),
    maintenance: path('', '/maintenance'),
    //app
    dashboard: path(ROOTS_APP, '/dashboard'),
    profile: path(ROOTS_APP, '/profile'),
    notificationSetting: path(ROOTS_APP, '/profile/notification'),
    profileKycReview: path(ROOTS_APP, '/profile/kyc'),
    profileCryptoWallet: path(ROOTS_APP, '/profile/crypto-wallet'),
    preference: path(ROOTS_APP, '/profile/preference'),
    security: path(ROOTS_APP, '/profile/security'),
    settings: path(ROOTS_APP, '/settings'),
    components: path(ROOTS_APP, '/components'),
    //kyc paths
    kyc: path(ROOTS_APP, '/kyc'),
    kyb: path(ROOTS_APP, '/kyb'),
    livePrice: path(ROOTS_APP, '/live-price'),
    accessControl: path(ROOTS_APP, '/user-management'),

    //help center
    helpCenter: path(ROOTS_APP, '/help-center'),
    support: path(ROOTS_APP, '/help-center/support'),
    supportDetail: (id) => path(ROOTS_APP, `/help-center/support/${id}`),
    newSupport: path(ROOTS_APP, '/help-center/support/newSupport'),
    QAndA: path(ROOTS_APP, '/help-center/q-and-a'),

    //api
    apiAccess: path(ROOTS_APP, '/apis'),
    apis: 'https://fox-client.readme.io/reference',
    apiLog: path(ROOTS_APP, '/apis/api-log'),
    apiKey: path(ROOTS_APP, '/apis/api-key'),

    //referral
    referralRoot: path(ROOTS_APP, '/referral'),
    referees: path(ROOTS_APP, '/referral/referees'),
    referralCommission: path(ROOTS_APP, '/referral/commission'),

    //funding
    funding: path(ROOTS_APP, '/funding'),
    fundingSummary: path(ROOTS_APP, '/funding/funding-summary'),
    deposits: path(ROOTS_APP, '/funding/deposits'),
    newDeposit: path(ROOTS_APP, '/funding/newDeposit'),
    withdrawals: path(ROOTS_APP, '/funding/withdrawals'),
    creatWithdrawal: path(ROOTS_APP, '/funding/withdrawals/creatWithdrawal'),
    withdrawalSuccess: path(
        ROOTS_APP,
        '/funding/withdrawals/withdrawalSuccess',
    ),
    transfers: path(ROOTS_APP, '/funding/transfers'),
    creatTransfer: path(ROOTS_APP, '/funding/transfers/creatTransfer'),
    transferSuccess: path(ROOTS_APP, '/funding/transfers/transferSuccess'),
    commissions: path(ROOTS_APP, '/funding/commissions'),
    moneyMove: path(ROOTS_APP, '/funding/moneyMove'),
    withdrawalAccounts: path(ROOTS_APP, '/funding/funding-withdrawal-accounts'),
    statements: path(ROOTS_APP, '/funding/statements'),

    channelDepositComplete: path(
        ROOTS_APP,
        '/funding/deposits/channel-deposit-complete',
    ),
    channelDepositCancel: path(
        ROOTS_APP,
        '/funding/deposits/channel-deposit-cancel',
    ),

    //accounts
    accounts: path(ROOTS_APP, '/mtAccounts'),
    accountsWithTypeId: (type, id) =>
        path(ROOTS_APP, `/mtAccounts?type=${type}&accountId=${id}`),


    //myAccounts
    myAccount: path(ROOTS_APP, '/myAccount'),

    //broker
    ibAgent: path(ROOTS_APP, '/ib-agent'),
    wiredAccounts: path(ROOTS_APP, '/ib-agent/wired-accounts'),
    ibOverview: path(ROOTS_APP, '/ib-agent/ib-overview'),
    ibSublevels: path(ROOTS_APP, '/ib-agent/ib-sublevels'),
    ibReports: path(ROOTS_APP, '/ib-agent/ib-reports'),
    pendingInvitations: path(ROOTS_APP, '/ib-agent/pending-invitations'),
    ibCampaigns: path(ROOTS_APP, '/ib-agent/campaigns'),
    ibCampaignPublish: (id) => path(ROOTS_APP, `/ib-agent/campaigns/publish/${id}`),
    // ib
    ib: path(ROOTS_APP, '/ib-agent'),

    newsPage: path(ROOTS_APP, '/newsPage'),
    //news
    news: path(ROOTS_APP, '/newsPage/news'),
    //news
    announcements: path(ROOTS_APP, '/newsPage/announcements'),

    //tools
    tools: path(ROOTS_APP, '/tools'),
    downloads: path(ROOTS_APP, '/downloads'),

    //help
    help: path(ROOTS_APP, '/help'),

    //About us
    aboutUs: path(ROOTS_APP, '/aboutUs'),

    //About us
    notification: path(ROOTS_APP, '/notification'),

    //ui-component
    uiComponent: path(ROOTS_APP, '/ui-component'),
    financeMonitoring: path(ROOTS_APP, '/ui-component/financeMonitoring'),
    eventsManagement: path(ROOTS_APP, '/ui-component/eventsManagement'),
    salesMonitoring: path(ROOTS_APP, '/ui-component/salesMonitoring'),
    websiteAnalytics: path(ROOTS_APP, '/ui-component/websiteAnalytics'),
    cryptocurrency: path(ROOTS_APP, '/ui-component/cryptocurrency'),
    helpdeskService: path(ROOTS_APP, '/ui-component/helpdeskService'),
    storageManagement: path(ROOTS_APP, '/ui-component/storageManagement'),
    productManagement: path(ROOTS_APP, '/ui-component/productManagement'),
};

export const adminPaths = {
    root: ROOTS_ADMIN,
    dashboard: path(ROOTS_ADMIN, '/dashboard'),

    //profile
    profile: path(ROOTS_ADMIN, '/profile'),
    notificationSetting: path(ROOTS_ADMIN, '/profile/notification'),
    preference: path(ROOTS_ADMIN, '/profile/preference'),
    security: path(ROOTS_ADMIN, '/profile/security'),

    //sales campaign (reuses information/campaigns pages)
    saleCampaignHome: path(ROOTS_ADMIN, '/campaign'),
    saleCampaignList: path(ROOTS_ADMIN, '/campaign/list'),
    saleCampaignPublish: (id) => path(ROOTS_ADMIN, `/campaign/publish/${id}`),
    saleCampaignRegisteredLeads: path(ROOTS_ADMIN, '/campaign/registered-leads'),
    saleCampaignConvertedClients: path(ROOTS_ADMIN, '/campaign/converted-clients'),
    saleCampaignBenefitsLogs: path(ROOTS_ADMIN, '/campaign/benefits-logs'),

    //clients
    clientsHome: path(ROOTS_ADMIN, '/clients'),
    clients: path(ROOTS_ADMIN, '/clients/clients'),
    clientDetail: (id) => path(ROOTS_ADMIN, `/clients/clients/${id}`),
    clientDetailWithTab: (id, tab) =>
        path(ROOTS_ADMIN, `/clients/clients/${id}?tab=${tab}`),
    404: '/404',
    403: '/403',

    clientsLeads: path(ROOTS_ADMIN, '/clients/clients-leads'),
    clientsAccounts: path(ROOTS_ADMIN, '/clients/clients-accounts'),
    clientCurrencyAccounts: path(ROOTS_ADMIN, '/clients/currency-accounts'),

    clientsRewireAccounts: path(ROOTS_ADMIN, '/clients/clients-rewire-accounts'),
    clientsPammAccounts: path(ROOTS_ADMIN, '/clients/clients-pamm-accounts'),
    clientsCCSubAccounts: path(ROOTS_ADMIN, '/clients/clients-cc-sub-accounts'),
    clientsIbAdmin: path(ROOTS_ADMIN, '/clients/clients-ib-admin'),
    managerSales: path(ROOTS_ADMIN, '/clients/manager-sales'),
    managerSupports: path(ROOTS_ADMIN, '/clients/manager-supports'),
    clientWithdrawalBanks: path(
        ROOTS_ADMIN,
        '/clients/client-withdrawal-banks',
    ),
    clientWithdrawalWallets: path(
        ROOTS_ADMIN,
        '/clients/client-withdrawal-wallets',
    ),
    clientDepositWallets: path(ROOTS_ADMIN, '/clients/client-deposit-wallets'),
    clientActivities: path(ROOTS_ADMIN, '/clients/client-activities'),
    demoAccounts: path(ROOTS_ADMIN, '/clients/demo-accounts'),

    // platform settings
    platformSettings: path(ROOTS_ADMIN, '/platform-settings'),

    //currency
    currencies: path(ROOTS_ADMIN, '/platform-settings/currencies'),
    currenciesPlatform: path(
        ROOTS_ADMIN,
        '/platform-settings/currencies/currencies-platform',
    ),
    currenciesAccounts: path(
        ROOTS_ADMIN,
        '/platform-settings/currencies/currencies-accounts',
    ),
    currenciesDefination: path(
        ROOTS_ADMIN,
        '/platform-settings/currencies/currencies-defination',
    ),
    currenciesWithdrawal: path(
        ROOTS_ADMIN,
        '/platform-settings/currencies/currencies-withdrawal',
    ),
    currenciesServiceFee: path(
        ROOTS_ADMIN,
        '/platform-settings/currencies/currencies-service-fee',
    ),

    //risk level
    riskLevel: path(ROOTS_ADMIN, '/platform-settings/risk-level'),
    // regulation region
    regulationRegion: path(ROOTS_ADMIN, '/platform-settings/regulation-region'),
    regulation: path(
        ROOTS_ADMIN,
        '/platform-settings/regulation-region/regulation-region',
    ),
    restrictedRegion: path(
        ROOTS_ADMIN,
        '/platform-settings/regulation-region/restricted-region',
    ),
    productRestrictionRegion: path(
        ROOTS_ADMIN,
        '/platform-settings/regulation-region/product-restriction-regions',
    ),

    //System products
    systemProducts: path(ROOTS_ADMIN, '/platform-settings/system-products'),

    //Trade products
    tradeProducts: path(ROOTS_ADMIN, '/platform-settings/trade-products'),

    //metadata
    metadata: path(ROOTS_ADMIN, '/platform-settings/metadata'),
    metadataCategory: path(
        ROOTS_ADMIN,
        '/platform-settings/metadata/metadata-category',
    ),
    metadataEdit: path(
        ROOTS_ADMIN,
        '/platform-settings/metadata/metadata-edit',
    ),

    //payment gateway
    paymentChannels: path(ROOTS_ADMIN, '/platform-settings/payment-channels'),
    paymentGateway: path(
        ROOTS_ADMIN,
        '/platform-settings/payment-channels/payment-gateway',
    ),
    blockchainGateway: path(
        ROOTS_ADMIN,
        '/platform-settings/payment-channels/blockchain',
    ),
    commonGateway: path(
        ROOTS_ADMIN,
        '/platform-settings/payment-channels/common-gateway',
    ),

    //intergation
    integration: path(ROOTS_ADMIN, '/platform-settings/integration'),
    KYCProvider: path(
        ROOTS_ADMIN,
        '/platform-settings/integration/kyc-provider',
    ),
    SMSEmailProvider: path(
        ROOTS_ADMIN,
        '/platform-settings/integration/sms-email-provider',
    ),
    MessagerProvider: path(
        ROOTS_ADMIN,
        '/platform-settings/integration/messager-provider',
    ),
    // access control
    accessControl: path(ROOTS_ADMIN, '/platform-settings/access-control'),
    systemRoles: path(
        ROOTS_ADMIN,
        '/platform-settings/access-control/system-roles',
    ),
    systemRoleAccess: path(
        ROOTS_ADMIN,
        '/platform-settings/access-control/system-role-access',
    ),
    userAutherization: path(
        ROOTS_ADMIN,
        '/platform-settings/access-control/user-autherization',
    ),
    adminAccessLog: path(
        ROOTS_ADMIN,
        '/platform-settings/access-control/admin-access-log',
    ),
    adminTree: path(
        ROOTS_ADMIN,
        '/platform-settings/access-control/admin-tree',
    ),
    clientAccessLog: path(
        ROOTS_ADMIN,
        '/platform-settings/access-control/client-access-log',
    ),

    //general settings
    generalSettings: path(ROOTS_ADMIN, '/platform-settings/general-settings'),
    systemSettings: path(
        ROOTS_ADMIN,
        '/platform-settings/general-settings/system-settings',
    ),
    clientPolicies: path(
        ROOTS_ADMIN,
        '/platform-settings/general-settings/client-policies',
    ),
    ibSettings: path(
        ROOTS_ADMIN,
        '/platform-settings/general-settings/ib-settings',
    ),

    // application management
    applicationManagement: path(ROOTS_ADMIN, '/application-management'),

    //api management
    apiManagement: path(ROOTS_ADMIN, '/application-management/api-management'),
    apiAutherization: path(
        ROOTS_ADMIN,
        '/application-management/api-management/api-autherization',
    ),
    apiAccessLog: path(
        ROOTS_ADMIN,
        '/application-management/api-management/api-access-log',
    ),
    apiErrorTracking: path(
        ROOTS_ADMIN,
        '/application-management/api-management/api-error-tracking',
    ),

    //system monitor
    systemMonitorHome: path(
        ROOTS_ADMIN,
        '/application-management/system-monitor',
    ),
    systemStatus: path(
        ROOTS_ADMIN,
        '/application-management/system-monitor/system-status',
    ),
    systemLog: path(
        ROOTS_ADMIN,
        '/application-management/system-monitor/system-log',
    ),
    systemAlert: path(
        ROOTS_ADMIN,
        '/application-management/system-monitor/system-alert',
    ),
    systemErrorTracking: path(
        ROOTS_ADMIN,
        '/application-management/system-monitor/system-error-tracking',
    ),
    systemScheduledTasks: path(
        ROOTS_ADMIN,
        '/application-management/system-monitor/system-scheduled-tasks',
    ),

    //security management
    securityManagement: path(
        ROOTS_ADMIN,
        '/application-management/security-management',
    ),
    ipAccessLog: path(
        ROOTS_ADMIN,
        '/application-management/security-management/ip-access-log',
    ),
    ipBlacklist: path(
        ROOTS_ADMIN,
        '/application-management/security-management/ip-blacklist',
    ),
    securityPolicy: path(
        ROOTS_ADMIN,
        '/application-management/security-management/security-policy',
    ),
    authRules: path(
        ROOTS_ADMIN,
        '/application-management/security-management/auth-rules',
    ),

    //bulk data
    bulkData: path(ROOTS_ADMIN, '/application-management/bulk-data'),
    clientsBulkData: path(
        ROOTS_ADMIN,
        '/application-management/bulk-data/clients-bulk-data',
    ),
    banksBulkData: path(
        ROOTS_ADMIN,
        '/application-management/bulk-data/banks-bulk-data',
    ),
    tradesBulkData: path(
        ROOTS_ADMIN,
        '/application-management/bulk-data/transactions-bulk-data',
    ),

    //finance
    finance: path(ROOTS_ADMIN, '/finance'),
    financeSummary: path(ROOTS_ADMIN, '/finance/finance-summary'),
    financeTransaction: path(ROOTS_ADMIN, '/finance/finance-transaction'),
    financeLedge: path(ROOTS_ADMIN, '/finance/finance-ledge'),
    financeExpenses: path(ROOTS_ADMIN, '/finance/finance-expenses'),
    financeRequests: path(ROOTS_ADMIN, '/finance/finance-requests'),

    //information
    informationHome: path(ROOTS_ADMIN, '/information'),
    informationAnnouncements: path(
        ROOTS_ADMIN,
        '/information/information-announcements',
    ),
    informationNewAnnouncement: path(
        ROOTS_ADMIN,
        '/information/information-announcements/new-announcement',
    ),
    informationAnnouncementDetail: (id) =>
        path(ROOTS_ADMIN, `/information/information-announcements/${id}`),
    informationNews: path(ROOTS_ADMIN, '/information/information-news'),
    informationHome: path(ROOTS_ADMIN, '/information/information-emails'),
    informationEmails: path(
        ROOTS_ADMIN,
        '/information/information-emails/information-email-list',
    ),
    informationNewEmail: path(
        ROOTS_ADMIN,
        '/information/information-emails/information-email-list/new-email',
    ),
    informationEmailDetail: (id) =>
        path(
            ROOTS_ADMIN,
            `/information/information-emails/information-email-list/${id}`,
        ),
    informationEmailTemplates: path(
        ROOTS_ADMIN,
        '/information/information-emails/information-email-template-list',
    ),
    informationNewEmailTemplate: path(
        ROOTS_ADMIN,
        '/information/information-emails/information-email-template-list/new-template',
    ),
    informationEmailTemplateDetail: (id) =>
        path(
            ROOTS_ADMIN,
            `/information/information-emails/information-email-template-list/${id}`,
        ),
    informationMessages: path(ROOTS_ADMIN, '/information/information-messages'),
    informationNewMessages: path(
        ROOTS_ADMIN,
        '/information/information-messages/new-message',
    ),
    informationMessageDetail: (id) =>
        path(ROOTS_ADMIN, `/information/information-messages/${id}`),
    informationAds: path(ROOTS_ADMIN, '/information/information-ads'),
    newAds: path(ROOTS_ADMIN, '/information/information-ads/createAds'),
    editAds: (id) => path(ROOTS_ADMIN, `/information/information-ads/${id}`),
    informationAccessSource: path(ROOTS_ADMIN, `/information/information-access-source`),
    informationCampaigns: path(ROOTS_ADMIN, `/information/information-access-source/campaigns`),
    informationCampaignsLogs: path(ROOTS_ADMIN, `/information/information-access-source/campaigns-logs`),
    informationCampaignsConvertedClients: path(ROOTS_ADMIN, `/information/information-access-source/converted-clients`),
    informationCampaignsRegisteredClients: path(ROOTS_ADMIN, `/information/information-access-source/registered-clients`),

    informationCampaignsNew: path(ROOTS_ADMIN, `/information/campaigns`),
    informationCampaignsList: path(ROOTS_ADMIN, `/information/campaigns/list`),
    informationCampaignsCreateEdit: path(ROOTS_ADMIN, `/information/campaigns/create-edit`),
    informationCampaignsPublish: (id) => path(ROOTS_ADMIN, `/information/campaigns/publish/${id}`),
    informationCampaignsTemplates: path(ROOTS_ADMIN, `/information/campaigns/templates`),
    informationCampaignsTemplatesCreateEdit: path(ROOTS_ADMIN, `/information/campaigns/templates/create-edit`),
    informationCampaignsNewRegisteredLeads: path(ROOTS_ADMIN, `/information/campaigns/registered-leads`),
    informationCampaignsNewConvertedClients: path(ROOTS_ADMIN, `/information/campaigns/converted-clients`),
    informationCampaignsNewSharedLogs: path(ROOTS_ADMIN, `/information/campaigns/shared-logs`),
    informationCampaignsNewAccessLogs: path(ROOTS_ADMIN, `/information/campaigns/access-logs`),
    informationCampaignsNewBenefitsLogs: path(ROOTS_ADMIN, `/information/campaigns/benefits-logs`),


    //supports
    supports: path(ROOTS_ADMIN, '/supports'),
    faq: path(ROOTS_ADMIN, '/supports/faq'),
    incidents: path(ROOTS_ADMIN, '/supports/incidents'),
    onlineSupport: path(ROOTS_ADMIN, '/supports/online-support'),
    tickets: path(ROOTS_ADMIN, '/supports/tickets'),
    ticketDetail: (id) => path(ROOTS_ADMIN, `/supports/tickets/${id}`),
    newTicket: path(ROOTS_ADMIN, '/supports/tickets/newTicket'),
    editFaq: path(ROOTS_ADMIN, '/supports/faq/editFaq'),
    newFaq: path(ROOTS_ADMIN, '/supports/faq/createFaq'),

    //transactions

    transactions: path(ROOTS_ADMIN, '/transactions'),
    transactionSummary: path(ROOTS_ADMIN, '/transactions/transaction-summary'),
    transactionDeposits: path(
        ROOTS_ADMIN,
        '/transactions/transaction-deposits',
    ),
    transactionWithdrawals: path(
        ROOTS_ADMIN,
        '/transactions/transaction-withdrawals',
    ),
    transactionTransfers: path(
        ROOTS_ADMIN,
        '/transactions/transaction-transfers',
    ),
    transactionCommissions: path(
        ROOTS_ADMIN,
        '/transactions/transaction-commissions',
    ),
    transactionAdjustments: path(
        ROOTS_ADMIN,
        '/transactions/transaction-adjustments',
    ),
    transactionMoneyMoves: path(
        ROOTS_ADMIN,
        '/transactions/transaction-money-moves',
    ),
    transactionHDWalletOperations: path(
        ROOTS_ADMIN,
        '/transactions/transaction-HDWallet-operations',
    ),
    transactionCredits: path(
        ROOTS_ADMIN,
        '/transactions/transaction-credits',
    ),

    //tasks
    tasks: path(ROOTS_ADMIN, '/tasks'),
    requests: path(ROOTS_ADMIN, '/tasks/requests'),
    requestSummary: path(ROOTS_ADMIN, '/tasks/requests/summary'),
    requestDeposits: path(ROOTS_ADMIN, '/tasks/requests/deposits'),
    requestWithdrawals: path(ROOTS_ADMIN, '/tasks/requests/withdrawals'),
    requestTransfer: path(ROOTS_ADMIN, '/tasks/requests/transfers'),
    requestLeverage: path(ROOTS_ADMIN, '/tasks/requests/leverages'),
    requestPassword: path(ROOTS_ADMIN, '/tasks/requests/passwords'),
    requestKyc: path(ROOTS_ADMIN, '/tasks/requests/kyc'),
    requestIB: path(ROOTS_ADMIN, '/tasks/requests/IB'),
    requestWithdrawalAccount: path(ROOTS_ADMIN, '/tasks/requests/bankAccounts'),
    requestWithdrawalWallet: path(ROOTS_ADMIN, '/tasks/requests/wallets'),
    requestGeneral: path(ROOTS_ADMIN, '/tasks/requests/generals'),
    requestAccount: path(ROOTS_ADMIN, '/tasks/requests/accounts'),
    requestExchangeWithdrawal: path(
        ROOTS_ADMIN,
        '/tasks/requests/exchangeWithdrawal',
    ),

    requestDepositsWithStatus: (status) =>
        path(ROOTS_ADMIN, `/tasks/requests/deposits?status=${status}`),
    requestWithdrawalsWithStatus: (status) =>
        path(ROOTS_ADMIN, `/tasks/requests/withdrawals?status=${status}`),
    requestTransferWithStatus: (status) =>
        path(ROOTS_ADMIN, `/tasks/requests/transfers?status=${status}`),
    requestLeverageWithStatus: (status) =>
        path(ROOTS_ADMIN, `/tasks/requests/leverages?status=${status}`),
    requestPasswordWithStatus: (status) =>
        path(ROOTS_ADMIN, `/tasks/requests/passwords?status=${status}`),
    requestGeneralWithStatus: (status) =>
        path(ROOTS_ADMIN, `/tasks/requests/generals?status=${status}`),
    requestAccountWithStatus: (status) =>
        path(ROOTS_ADMIN, `/tasks/requests/accounts?status=${status}`),
    requestKycWithStatus: (status) =>
        path(ROOTS_ADMIN, `/tasks/requests/kyc?status=${status}`),
    requestIBWithStatus: (status) =>
        path(ROOTS_ADMIN, `/tasks/requests/IB?status=${status}`),
    requestWithdrawalAccountWithStatus: (status) =>
        path(ROOTS_ADMIN, `/tasks/requests/bankAccounts?status=${status}`),
    requestWithdrawalWalletWithStatus: (status) =>
        path(ROOTS_ADMIN, `/tasks/requests/wallets?status=${status}`),

    myTasks: path(ROOTS_ADMIN, '/tasks/my-tasks'),

    //taskboard
    taskboard: path(ROOTS_ADMIN, '/tasks/taskboard'),
    taskboardKyc: path(ROOTS_ADMIN, '/tasks/taskboard/taskboard-kyc'),
    taskboardWithdrawalAccount: path(
        ROOTS_ADMIN,
        '/tasks/taskboard/taskboard-withdrawal-account',
    ),
    taskboardDeposits: path(ROOTS_ADMIN, '/tasks/taskboard/taskboard-deposits'),
    taskboardWithdrawals: path(
        ROOTS_ADMIN,
        '/tasks/taskboard/taskboard-withdrawals',
    ),
    taskboardTransfer: path(ROOTS_ADMIN, '/tasks/taskboard/taskboard-transfer'),

    taskboardLeverage: path(ROOTS_ADMIN, '/tasks/taskboard/taskboard-leverage'),

    taskboardPassword: path(ROOTS_ADMIN, '/tasks/taskboard/taskboard-password'),

    taskboardGeneral: path(ROOTS_ADMIN, '/tasks/taskboard/taskboard-general'),

    //risk management
    riskManagement: path(ROOTS_ADMIN, '/risk-management'),

    //approvals
    approvals: path(ROOTS_ADMIN, '/risk-management/approvals'),
    approvalsMt45Accounts: path(
        ROOTS_ADMIN,
        '/risk-management/approvals/approvals-mt45-accounts',
    ),
    approvalsKyc: path(ROOTS_ADMIN, '/risk-management/approvals/approvals-kyc'),
    approvalsWithdrawalWallet: path(
        ROOTS_ADMIN,
        '/risk-management/approvals/approvals-withdrawal-wallet',
    ),
    approvalsIbApplications: path(
        ROOTS_ADMIN,
        '/risk-management/approvals/approvals-ib-applications',
    ),
    approvalsWithdrawalAccount: path(
        ROOTS_ADMIN,
        '/risk-management/approvals/approvals-withdrawal-account',
    ),
    approvalsFxWithdrawals: path(
        ROOTS_ADMIN,
        '/risk-management/approvals/approvals-withdrawals',
    ),
    approvalsDebitCard: path(
        ROOTS_ADMIN,
        '/risk-management/approvals/approvals-debit-card',
    ),

    riskMtTradeMonitorTotal: path(ROOTS_ADMIN, '/risk-report/mt-monitor/total'),
    riskMtTradeMonitorCurrency: path(
        ROOTS_ADMIN,
        '/risk-report/mt-monitor/currency',
    ),
    riskMtTradeMonitorSymbol: path(
        ROOTS_ADMIN,
        '/risk-report/mt-monitor/symbol',
    ),

    // risk report
    riskReports: path(ROOTS_ADMIN, '/risk-management/risk-reports'),
    salesReports: path(
        ROOTS_ADMIN,
        '/risk-management/risk-reports/sales-reports',
    ),

    taskReports: path(
        ROOTS_ADMIN,
        '/risk-report/task-reports',
    ),
    //notification
    notification: path(ROOTS_ADMIN, '/notification'),
    confidencialDetail: (login) =>
        path(ROOTS_ADMIN, `/confidencial/pamm-detail/${login}`),
    pammAccountList: path(ROOTS_ADMIN, '/confidencial/pamm/'),
    pammAccountSummary: path(ROOTS_ADMIN, '/confidencial/dashboard'),

    apis: 'https://fox-admin.readme.io/reference',

};

export const PATH_AFTER_LOGIN = paths.dashboard;
export const PATH_AFTER_ADMIN_LOGIN = adminPaths.dashboard;
export const PATH_TO_REDIRECTOR = paths.redirector;

export const navDrawerConfig = ({
                                    isIB,
                                    platformBasicInfo,
                                }) => {
    return [
        {
            labelKey: 'home',
            value: 'dashboard',
            path: paths.dashboard,
            Icon: HiHome,
            kycValid: false,
        },
        // {
        //     labelKey: 'accounts',
        //     value: 'accounts',
        //     path: paths.accounts,
        //     Icon: MdAccountBalance,
        //     kycValid: false,
        // },
        {
            labelKey: 'myAccount',
            value: 'myAccount',
            path: paths.myAccount,
            Icon: MdAccountBalance,
            kycValid: false,
        },
        {
            labelKey: 'funds',
            value: 'funding',
            path: paths.funding,
            Icon: RiFundsBoxFill,
            kycValid: true,
        },
        ...(isIB
            ? [
                {
                    labelKey: 'ibAgentAndReferrals',
                    value: 'ibAgent',
                    path: paths.ibAgent,
                    Icon: BsPersonBadge,
                    kycValid: true,
                },
            ]
            : []),
        {
            labelKey: 'APIs',
            value: 'explorer',
            // path: paths.apis,
            Icon: HiCreditCard,
            external: true,
            kycValid: false,
        },
          {
            labelKey: 'uiComponent',
            value: 'uiComponent',
            path: paths.uiComponent,
            Icon: IoBarChartSharp,
            kycValid: false,
            subMenu: true,
            paths: [
               {
                    labelKey: 'financeMonitoring',
                    value: 'financeMonitoring',
                    path: paths.financeMonitoring,
                },
                {
                    labelKey: 'eventsManagement',
                    value: 'eventsManagement',
                    path: paths.eventsManagement,
                },
                {
                    labelKey: 'salesMonitoring',
                    value: 'salesMonitoring',
                    path: paths.salesMonitoring,
                },
                {
                    labelKey: 'websiteAnalytics',
                    value: 'websiteAnalytics',
                    path: paths.websiteAnalytics,
                },
                {
                    labelKey: 'cryptocurrency',
                    value: 'cryptocurrency',
                    path: paths.cryptocurrency,
                },
                {
                    labelKey: 'helpdeskService',
                    value: 'helpdeskService',
                    path: paths.helpdeskService,
                },
                {
                    labelKey: 'storageManagement',
                    value: 'storageManagement',
                    path: paths.storageManagement,
                },
                {
                    labelKey: 'productManagement',
                    value: 'productManagement',
                    path: paths.productManagement,
                },
            ]

        },
        {
            labelKey: 'about',
            value: 'aboutUs',
            path: platformBasicInfo?.officialWebsite,
            Icon: FaInfoCircle,
            kycValid: false,
            external: true,
        },
    ];
};

export const navDrawerAdminConfig = ({getPermission, isReadOnlyAdmin}) => [
    {
        labelKey: 'dashboard',
        value: 'dashboard',
        path: adminPaths.dashboard,
        Icon: HiHome,
        kycValid: false,
        // hasPermission: getPermission('dashboard'),
    },
    {
        labelKey: 'tasks',
        value: 'tasks',
        path: adminPaths.tasks,
        Icon: HiClipboardList,
        kycValid: false,
        subMenu: true,
        hasPermission: getPermission('tasks'),
        paths: [
            {
                labelKey: 'requests',
                value: 'requests',
                path: adminPaths.requests,
                hasPermission: getPermission('tasks.requests'),
            },
            {
                labelKey: 'taskboard',
                value: 'taskboard',
                path: adminPaths.taskboard,
                hasPermission: getPermission('tasks.taskboard'),
            },
            {
                labelKey: 'myTasks',
                value: 'myTasks',
                path: adminPaths.myTasks,
                hasPermission: getPermission('tasks.myTasks'),
            },
        ],
    },
    {
        labelKey: 'riskApprovals',
        value: 'approvals',
        path: adminPaths.approvals,
        hasPermission: getPermission('riskManagement.approvals'),
        kycValid: false,
        Icon: HiShieldCheck,
    },
    {
        labelKey: 'clients',
        value: 'clients',
        path: adminPaths.clientsHome,
        Icon: HiUserGroup,
        kycValid: false,
        subMenu: true,
        hasPermission: getPermission('clientsHome'),
        paths: [
            {
                labelKey: 'clients',
                value: 'clients',
                path: adminPaths.clients,
                hasPermission: getPermission('clientsHome.clients'),
            },
            {
                labelKey: 'clientsLeads',
                value: 'clientsLeads',
                path: adminPaths.clientsLeads,
                hasPermission: getPermission('clientsHome.clientsLeads'),
            },
            {
                labelKey: 'currencyAccounts',
                value: 'currencyAccounts',
                path: adminPaths.clientCurrencyAccounts,
                hasPermission: getPermission('clientsHome.clientsAccounts'),
            },
            {
                labelKey: 'clientsIbAdmin',
                value: 'clientsIbAdmin',
                path: adminPaths.clientsIbAdmin,
                hasPermission: getPermission('clientsHome.clientsIbAdmin'),
            },
            {
                labelKey: 'managerSales',
                value: 'managerSales',
                path: adminPaths.managerSales,
                hasPermission: getPermission('clientsHome.managerSales'),
            },
            {
                labelKey: 'managerSupports',
                value: 'managerSupports',
                path: adminPaths.managerSupports,
                hasPermission: getPermission('clientsHome.managerSupports'),
            },
            {
                labelKey: 'clientWithdrawalBanks',
                value: 'clientWithdrawalBanks',
                path: adminPaths.clientWithdrawalBanks,
                hasPermission: getPermission(
                    'clientsHome.clientWithdrawalBanks',
                ),
            },
            {
                labelKey: 'clientWithdrawalWallets',
                value: 'clientWithdrawalWallets',
                path: adminPaths.clientWithdrawalWallets,
                hasPermission: getPermission(
                    'clientsHome.clientWithdrawalWallets',
                ),
            },
            {
                labelKey: 'clientDepositWallets',
                value: 'clientDepositWallets',
                path: adminPaths.clientDepositWallets,
                hasPermission: getPermission(
                    'clientsHome.clientDepositWallets',
                ),
            },
            {
                labelKey: 'clientActivities',
                value: 'clientActivities',
                path: adminPaths.clientActivities,
                hasPermission: getPermission(
                    'clientsHome.clientDepositWallets',
                ),
            },
            // {
            //     labelKey: 'demoAccounts',
            //     value: 'demoAccounts',
            //     path: adminPaths.demoAccounts,
            //     hasPermission: getPermission(
            //         'clientsHome.demoAccounts',
            //     ),
            // },
        ],
    },
    {
        labelKey: 'transactions',
        value: 'transactions',
        path: adminPaths.transactions,
        Icon: BsCurrencyExchange,
        kycValid: false,
        hasPermission: getPermission('transactions'),
    },
    {
        labelKey: 'supports',
        value: 'supports',
        path: adminPaths.supports,
        Icon: HiTicket,
        kycValid: false,
        subMenu: true,
        hasPermission: getPermission('supports'),
        paths: [
            {
                labelKey: 'tickets',
                value: 'tickets',
                path: adminPaths.tickets,
                hasPermission: getPermission('supports.tickets'),
            },
            {
                labelKey: 'faq',
                value: 'faq',
                path: adminPaths.faq,
                hasPermission: getPermission('supports.faq'),
            },
        ],
    },
    {
        labelKey: 'informationCenter',
        value: 'informationCenter',
        path: adminPaths.informationHome,
        Icon: IoInformationCircle,
        kycValid: false,
        subMenu: true,
        hasPermission: getPermission('informationHome'),
        paths: [
            {
                labelKey: 'informationAnnouncements',
                value: 'informationAnnouncements',
                path: adminPaths.informationAnnouncements,
                hasPermission: getPermission(
                    'informationHome.informationAnnouncements',
                ),
            },
            {
                labelKey: 'informationAds',
                value: 'informationAds',
                path: adminPaths.informationAds,
                hasPermission: getPermission('informationHome.informationAds'),
            },
            {
                labelKey: 'informationEmails',
                value: 'informationEmails',
                path: adminPaths.informationHome,
                hasPermission: getPermission(
                    'informationHome.informationEmails',
                ),
            },
            {
                labelKey: 'informationMessages',
                value: 'informationMessages',
                path: adminPaths.informationMessages,
                hasPermission: getPermission(
                    'informationHome.informationMessages',
                ),
            },
            {
                labelKey: 'externalCampaigns',
                value: 'externalCampaigns',
                path: adminPaths.informationAccessSource,
                hasPermission: getPermission(
                    'informationHome.informationAccessSource',
                ),
            },
            {
                labelKey: 'campaignsNew',
                value: 'campaignsNew',
                path: adminPaths.informationCampaignsNew,
                hasPermission: getPermission('informationHome.Campaign'),
            },
        ],
    },
    {
        labelKey: 'campaigns',
        value: 'saleCampaign',
        path: adminPaths.saleCampaignHome,
        Icon: HiGiftTop,
        kycValid: false,
        hasPermission: getPermission('saleCampaign'),
    },
    {
        labelKey: 'finance',
        value: 'finance',
        path: adminPaths.finance,
        Icon: HiCurrencyDollar,
        kycValid: false,
        hasPermission: getPermission('finance'),
    },
    {
        labelKey: 'apiExplorer',
        value: 'explorer',
        path: adminPaths.apis,
        Icon: HiCreditCard,
        kycValid: false,
        external: true,
    },
    {
        labelKey: 'platformSettings',
        value: 'platformSettings',
        path: 'platform-settings',
        subMenu: true,
        Icon: HiCog8Tooth,
        path: adminPaths.platformSettings,
        hasPermission: getPermission('platformSettings'),
        paths: [
            {
                labelKey: 'generalSettings',
                value: 'generalSettings',
                path: adminPaths.generalSettings,
                hasPermission: getPermission(
                    'platformSettings.generalSettings',
                ),
            },
            {
                labelKey: 'currencies',
                value: 'currencies',
                path: adminPaths.currencies,
                hasPermission: getPermission('platformSettings.currencies'),
            },
            {
                labelKey: 'paymentChannels',
                value: 'paymentChannels',
                path: adminPaths.paymentChannels,
                hasPermission: getPermission(
                    'platformSettings.paymentChannels',
                ),
            },
            {
                labelKey: 'integration',
                value: 'integration',
                path: adminPaths.integration,
                hasPermission: getPermission('platformSettings.integration'),
            },
            {
                labelKey: 'metadata',
                value: 'metadata',
                path: adminPaths.metadata,
                hasPermission: getPermission('platformSettings.metadata'),
            },
            ...(isReadOnlyAdmin
                ? []
                : [
                    {
                        labelKey: 'accessControl',
                        value: 'accessControl',
                        path: adminPaths.accessControl,
                        hasPermission: getPermission('platformSettings.accessControl'),
                    },
                ]),
            {
                labelKey: 'riskLevel',
                value: 'riskLevel',
                path: adminPaths.riskLevel,
                hasPermission: getPermission('platformSettings.riskLevel'),
            },
            {
                labelKey: 'regulationRegion',
                value: 'regulationRegion',
                path: adminPaths.regulationRegion,
                hasPermission: getPermission(
                    'platformSettings.regulationRegion',
                ),
            },
            {
                labelKey: 'systemProducts',
                value: 'systemProducts',
                path: adminPaths.systemProducts,
                hasPermission: getPermission('platformSettings.systemProducts'),
            },
            {
                labelKey: 'tradeProducts',
                value: 'tradeProducts',
                path: adminPaths.tradeProducts,
                hasPermission: getPermission('platformSettings.tradeProducts'),
            },
        ],
    },
];
